export const hexToRgba = (hex, opacity = 1) => {
    if (hex.length === 7) {
        const value = hex.slice(1);
        const valueArr = [[value[0], value[1]], [value[2], value[3]], [value[4], value[5]]];
        const rgbaArr = valueArr.map(([test1, test2]) => parseInt(test1 + test2, 16));
        return `rgba(${rgbaArr[0]}, ${rgbaArr[1]}, ${rgbaArr[2]}, ${opacity})`;
    }
};
